import axios from 'axios'
import router from '@/router'
import i18n from '../../plugins/i18n'
import {Trans} from "@/plugins/Translation"

export default {
  state: {
    answerItems: [],
    publicAnswerStatusId: null,
    unpublicAnswerStatusId: null,
    hiddenAnswerStatusId: null,
    deleteAnswerStatusId: null,
    publicCommentStatusId: null,
    hiddenCommentStatusId: null,
    hiddenByComplaintCommentStatusId: null,
    moderationCommentStatusId: null,
    deleteCommentStatusId: null,
    currentUser: null
  },
  mutations: {
    setAnswerItems(state, items) {
      state.answerItems = items
    },
    setPublicAnswerStatusId(state, item) {
      state.publicAnswerStatusId = item
    },
    setUnpublicAnswerStatusId(state, item) {
      state.unpublicAnswerStatusId = item
    },
    setHiddenAnswerStatusId(state, item) {
      state.hiddenAnswerStatusId = item
    },
    setDeleteAnswerStatusId(state, item) {
      state.deleteAnswerStatusId = item
    },
    setPublicCommentStatusId(state, item) {
      state.publicCommentStatusId = item
    },
    setHiddenCommentStatusId(state, item) {
      state.hiddenCommentStatusId = item
    },
    setHiddenByComplaintCommentStatusId(state, item) {
      state.hiddenByComplaintCommentStatusId = item
    },
    setModerationCommentStatusId(state, item) {
      state.moderationCommentStatusId = item
    },
    setDeleteCommentStatusId(state, item) {
      state.deleteCommentStatusId = item
    },
    setCurrentUser(state, item) {
      state.currentUser = item
    }
  },
  // данные проекта НПА
  getNpaData() {
    return axios.get(`${i18n.locale}/api/npa/npaFormData`)
  },
  // данные справочников проекта НПА
  getNpaDataReferences(reference, oldParams = '') {
    return axios.get(`${i18n.locale}/api/npa/references?ref=${reference}&${oldParams}`)
  },
  // обвновление проекта НПА
  updateNpa(data, id) {
    return axios.patch(`${i18n.locale}/api/npa/editNpa/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  // добавление документа НПА
  addNpaDocument(data, id) {
    return axios.post(`${i18n.locale}/api/npa/addNpaDocument/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  // удаление документа НПА
  deleteNpaDocument(id, npaDocument) {
    return axios.delete(
      `${i18n.locale}/api/npa/deleteNpaDocument/${id}/${npaDocument}`
    )
  },
  // добавление/редактирование файла версии
  editNpaVersionFile(versionId, npaId, lang, data) {
    return axios.post(
      `${i18n.locale}/api/npa/editNpaVersionFile/${versionId}/${npaId}?lang=${lang}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
  },
  // удаление блока версии НПА
  deleteNpaBlock(blockId, versionId) {
    return axios.delete(
      `${i18n.locale}/api/npa/deleteNpaVersionBlock/${blockId}/${versionId}`
    )
  },
  // добавление блока
  addNpaVersionBlock(npaId, versionId, routeParam, data) {
    return axios.post(`${i18n.locale}/api/npa/createNpaVersionBlock/${npaId}/${versionId}${routeParam}`, data)
  },
  // редактирование блока
  editNpaVersionBlock(blockId, versionId, data) {
    return axios.patch(`${i18n.locale}/api/npa/editNpaVersionBlock/${blockId}/${versionId}`, data)
  },

  status(id, data) {
    return axios.post(`${i18n.locale}/api/npa/status/${id}`, data)
  },

  actions: {
    fetchNpaData() {
      return axios.get(`${i18n.locale}/api/npa/npaFormData`).then((response) => {
        return Promise.resolve(response.data)
      }).catch((error) => {
        router.push(Trans.i18nRoute({
          name: 'error',
          params: {
            status: error.response.status
          }
        }))
      })
    },
    fetchOfferData() {
      return axios.get(`${i18n.locale}/api/offer/offerFormData`).then((response) => {
        return Promise.resolve(response.data)
      })
    },
    fetchAnswerItems({commit}) {
      return axios
        .get(`${i18n.locale}/api/public/search/npaCommentAnswerFormData`)
        .then(({data}) => {
          commit('setAnswerItems', data.refCommentReviewResult)
          commit('setPublicAnswerStatusId', data.publicAnswerStatusId)
          commit('setUnpublicAnswerStatusId', data.unpublicAnswerStatusId)
          commit('setHiddenAnswerStatusId', data.hiddenAnswerStatusId)
          commit('setDeleteAnswerStatusId', data.deleteAnswerStatusId)
          commit('setPublicCommentStatusId', data.publicCommentStatusId)
          commit('setHiddenCommentStatusId', data.hiddenCommentStatusId)
          commit('setHiddenByComplaintCommentStatusId', data.hiddenByComplaintCommentStatusId)
          commit('setModerationCommentStatusId', data.moderationCommentStatusId)
          commit('setDeleteCommentStatusId', data.deleteCommentStatusId)
          commit('setCurrentUser', data.currentUser)
          return Promise.resolve(data)
        })
    }
  }
}
